import {
  faBug,
  faPlusCircle,
  faStar,
  faTools
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ListGroup, Modal } from 'react-bootstrap';

const NewReleaseModal = ({ show, handleClose }) => {
  const newFeatures = [
    {
      title: 'Lançamento de apontamento retroativo com regularização de SLA',
      description:
        'Agora é possível lançar apontamentos retroativos com regularização de SLA, garantindo maior transparência e controle sobre o atendimento.',
      highlight: true
    },
    {
      title: 'Blacklist para envio de notificações por e-mail',
      description:
        'Agora é possível bloquear e-mails específicos para evitar envios indesejados, melhorando a segurança e a privacidade dos usuários.'
    }
  ];

  const improvements = [
    {
      title: 'Convite ao portal do cliente white-label',
      description:
        'Agora o e-mail de convite ao portal do cliente pode ser personalizado com o logo da empresa, garantindo maior identidade visual e personalização.',
      highlight: true
    },
    {
      title: 'Validação de CNPJ e CPF no cadastro de clientes',
      description:
        'Agora é possível validar CNPJ e CPF no cadastro de clientes, garantindo maior precisão e segurança dos dados.'
    },
    {
      title: 'Itens faturáveis na impressão do ticket',
      description:
        'Foi adicionado os itens faturáveis na impressão do ticket, garantindo maior transparência e controle sobre o atendimento.',
      highlight: true
    },
    {
      title: 'Anexo de respostas ao ticket vindo do Com Cópia (CC)',
      description:
        'Agora quem foi adicionado no Com Cópia (CC) na resposta de um ticket também consegue interagir com o ticket.'
    },
    {
      title: 'Melhoria na legibilidade de campos na importação de clientes',
      description:
        'Agora os campos na importação de clientes estão mais legíveis e organizados, facilitando o preenchimento e a compreensão dos dados.'
    },
    {
      title: 'Melhoria na nomenclatura de campos na importação de contatos',
      description:
        'Agora os campos na importação de contato estão mais legíveis e organizados, facilitando o preenchimento e a compreensão dos dados.'
    },
    {
      title: 'Otimização na busca de tickets',
      description:
        'Agora a busca de tickets é mais rápida e eficiente, garantindo maior produtividade e rapidez na navegação.',
      highlight: true
    }
  ];

  const bugFixes = [
    {
      title: 'Correção na impressão do ticket',
      description:
        'Corrigido erro na impressão do ticket para empresas que não tinham o cadastro completo.'
    },
    {
      title: 'Ações de notas do ticket não visíveis',
      description:
        'Corrigido erro na exibição das ações de notas do ticket, garantindo o gerencimaneto de notas do ticket.'
    },
    {
      title: 'Erro ao concluir tarefas pelas ações em lote',
      description:
        'Corrigido erro na conclusão de tarefas pelas ações em lote, garantindo o gerencimaneto de tarefas do ticket.'
    },
    {
      title: 'Relatórios personalizados com horário de execução incorreto',
      description:
        'Corrigido erro na execução dos relatórios personalizados com horário de execução incorreto, garantindo o gerencimaneto de relatórios personalizados.'
    }
  ];

  const renderList = (items, icon, colorClass) =>
    items.map((item, idx) => (
      <ListGroup.Item
        key={idx}
        variant={item.highlight ? 'success' : ''}
        className="d-flex flex-column"
      >
        <div className="d-flex align-items-center mb-1">
          <FontAwesomeIcon icon={icon} className={`me-2 ${colorClass}`} />
          <strong className="me-2">{item.title}</strong>
          {item.highlight && (
            <FontAwesomeIcon
              icon={faStar}
              className="text-warning ms-auto"
              title="Destaque"
            />
          )}
        </div>
        <small className="text-muted fst-italic">{item.description}</small>
      </ListGroup.Item>
    ));

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="me-2 fw-bold">Notas da Nova Versão</Modal.Title>
        <span className="text-muted fs-10 text-end">11/02/2026</span>
      </Modal.Header>
      <Modal.Body>
        <h5>
          <FontAwesomeIcon icon={faPlusCircle} className="me-2 text-success" />
          Novas funcionalidades
        </h5>
        <ListGroup className="mb-4">
          {renderList(newFeatures, faPlusCircle, 'text-success')}
        </ListGroup>

        <h5>
          <FontAwesomeIcon icon={faTools} className="me-2 text-warning" />
          Melhorias
        </h5>
        <ListGroup className="mb-4">
          {renderList(improvements, faTools, 'text-warning')}
        </ListGroup>

        <h5>
          <FontAwesomeIcon icon={faBug} className="me-2 text-danger" />
          Correções de erros
        </h5>
        <ListGroup>{renderList(bugFixes, faBug, 'text-danger')}</ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewReleaseModal;
